import { axios_instance } from "../api/axios_instance";
import Timer from "../layouts/Timer";
import { BANKBOX_WEBHOOK_CHECK_TIME } from "./constant";
import { decryptRequest, encryptRequest } from "./encryptdecryptrequest";
import { convertToUTCFormat } from "./format";

const getTableStyles = (activeTab) => {
  switch (activeTab) {
    case 0:
      return `.bankboxlist-lead-id{
        width: 7%;
      }
      .bankboxlist-tranche{
        width: 9%;
      }
      .bankboxlist-payment-amount{
          width: 8%;
      }
      .bankboxlist-request-date{
          width: 8%;
      }
      .bankboxlist-bank{
          width: 10%;
      }
      .bankboxlist-time-lapsed{
          width: 7%;
      }
      .bankboxlist-status{
          width: 13%;
      }
      .bankboxlist-action{
          width: 10%;
      }`;
    case 1:
      return `.bankboxlist-lead-id{
        width: 9%;
      }
      .bankboxlist-tranche{
        width: 11%;
      }
      .bankboxlist-payment-amount{
          width: 17%;
      }
      .bankboxlist-request-date{
          width: 15%;
      }
      .bankboxlist-status{
          width: 17%;
      }
      .bankboxlist-bank-status{
        width: 13%:
      }
      .bankboxlist-action{
          width: 13%;
      }`;
    case 2:
      return `.bankboxlist-lead-id{
        width: 5%;
      }
      .bankboxlist-tranche{
        width: 5%;
      }
      .bankboxlist-payment-amount{
          width: 10%;
      }
      .bankboxlist-request-date{
          width: 9%;
      }
      .bankboxlist-bank{
        width: 10%;
      }
      .bankboxlist-hold-by{
        width: 5%;
      }
      .bankboxlist-hold-time{
        width: 8%:
      }
      .bankboxlist-reason{
        width: 20%;
      }
      .bankboxlist-status{
        width: 12%;
      }
      .bankboxlist-action{
          width: 15%;
      }`;
    case 3:
      return `.bankboxlist-lead-id{
        width: 8%;
      }
      .bankboxlist-tranche{
        width: 8%;
      }
      .bankboxlist-payment-amount{
          width: 10%;
      }
      .bankboxlist-request-date{
          width: 8%;
      }
      .bankboxlist-bank{
        width: 15%;
      }
      .bankboxlist-completed-time{
        width: 12%;
      }
      .bankboxlist-reversed-time{
        width: 12%;
      }
      .bankboxlist-status{
        width: 14%;
      }
      .bankboxlist-bank-status{
        width: 11%:
      }
      .bankboxlist-action{
          width: 12%;
      }`;
    case 4:
      return `.bankboxlist-lead-id{
        width: 6%;
      }
      .bankboxlist-tranche{
        width: 5%;
      }
      .bankboxlist-payment-amount{
          width: 8%;
      }
      .bankboxlist-request-date{
          width: 8%;
      }
      .bankboxlist-bank{
        width: 15%;
      }
      .bankboxlist-cancelled-by{
        width: 7%;
      }
      .bankboxlist-status{
        width: 7%;
      }
      .bankboxlist-cancelled-time{
        width: 7%:
      }
      .bankboxlist-reason{
        width: 20%;
      }
      .bankboxlist-action{
          width: 15%;
      }`;
    case 5:
      return `.bankboxlist-lead-id{
          width: 5.5%;
        }
        .bankboxlist-tranche{
          width: 5.2%;
        }
        .bankboxlist-payment-amount{
            width: 8.5%;
        }
        .bankboxlist-request-date{
            width: 9%;
        }
        .bankboxlist-bank{
          width: 8%;
        }
        .bankboxlist-hold-cancelled-failed-time{
          width: 9%:
        }
        .bankboxlist-status{
          width: 8%;
        }
        .bankboxlist-bank-status{
          width: 8%:
        }
        .bankboxlist-reason{
          width: 28%;
        }`;
    default:
      break;
  }
};

const getSortingClass = (sortingColumns, column) => {
  return sortingColumns[column] === 1
    ? "_asc"
    : sortingColumns[column] === -1
      ? "_desc"
      : "";
};

const getTimeLapsedDiv = (payment_req_date, default_execution_time) => {
  let timeLapsed = 0,
    timeLapsedDiv = "",
    showBtn = true,
    diff = 0;
  if (payment_req_date) {
    const toTime = new Date();
    const fromTime = new Date(
      convertToUTCFormat(payment_req_date, "yyyy-MM-dd HH:mm:ss"),
    );

    diff = Math.round(Math.abs((toTime - fromTime) / 1000));
    timeLapsed = Math.round(diff / 60);

    if (timeLapsed >= default_execution_time) {
      timeLapsed = 0;
      showBtn = false;
    } else {
      timeLapsed = default_execution_time - timeLapsed;
      diff = default_execution_time * 60 - diff;
    }
  }

  if (timeLapsed > 0) {
    timeLapsedDiv = <Timer totalTimeInSeconds={diff} endingMinutes={0} />;
  } else {
    timeLapsedDiv = <div className="jst-timeout btn btn-sm">00:00:00</div>;
  }

  return { timeLapsedDiv, showBtn };
};

const getActionDiv = (
  bank_txn_status,
  next_executeion_time,
  queue_status,
  created,
  txn_id,
  trancheID,
  activeTab,
  bankBoxPanelState,
  setBankBoxPanelState,
  fetchListData,
) => {
  let actionDiv = "--";

  switch (activeTab) {
    case 1:
      if (next_executeion_time) {
        const fromTime = new Date(next_executeion_time.slice(0, -1));
        const toTime = new Date();

        let timeLapsed = (fromTime - toTime) / 1000;
        if (timeLapsed > 0) {
          actionDiv = <Timer totalTimeInSeconds={Math.round(timeLapsed)} />;
        }
      } else if (bank_txn_status === 5 && queue_status === 1) {
        const fromTime = new Date(created);
        const toTime = new Date();
        let timeLapsed = Math.round(Math.abs((fromTime - toTime) / 1000));
        if (timeLapsed > BANKBOX_WEBHOOK_CHECK_TIME * 60) {
          actionDiv = (
            <button
              className="btn btn-xs btn-success mrg-all-0 bankbox-success-btn"
              onClick={() =>
                updateTransaction(
                  txn_id,
                  trancheID,
                  "retry_webhook",
                  "",
                  "",
                  setBankBoxPanelState,
                  fetchListData,
                )
              }
              disabled={bankBoxPanelState.manualActionBtnDisabled[txn_id]}
            >
              Retry&nbsp;
            </button>
          );
        }
      }
      break;
    case 2:
    case 4:
      if (bank_txn_status === 3) {
        actionDiv = (
          <>
            <button
              className="btn btn-xs btn-success mrg-all-0 bankbox-success-btn"
              onClick={() =>
                updateTransaction(
                  txn_id,
                  trancheID,
                  "release",
                  "",
                  "",
                  setBankBoxPanelState,
                  fetchListData,
                )
              }
              disabled={bankBoxPanelState.manualActionBtnDisabled[txn_id]}
            >
              Release
            </button>
            &nbsp; &nbsp;
            <button
              className="btn btn-xs btn-warning mrg-all-0 bankbox-warning-btn"
              onClick={(e) =>
                openReasonModal(
                  trancheID,
                  "resubmit",
                  bankBoxPanelState,
                  setBankBoxPanelState,
                  e,
                )
              }
              disabled={bankBoxPanelState.manualActionBtnDisabled[txn_id]}
            >
              Resubmit
            </button>
          </>
        );
      } else if (bank_txn_status === 7) {
        if (next_executeion_time) {
          const fromTime = new Date(next_executeion_time.slice(0, -1));
          const toTime = new Date();
          let timeLapsed = (fromTime - toTime) / 1000;
          if (timeLapsed > 0) {
            actionDiv = (
              <button
                className="btn btn-xs btn-danger disabled-anchor mrg-all-0 txn-timer bankbox-danger-btn"
                onClick={(e) =>
                  manualActionButtonClicked(
                    txn_id,
                    trancheID,
                    bankBoxPanelState,
                    setBankBoxPanelState,
                    e,
                  )
                }
                disabled={bankBoxPanelState.manualActionBtnDisabled[txn_id]}
              >
                <Timer
                  totalTimeInSeconds={Math.round(timeLapsed)}
                  endingMinutes={0}
                  textWithTimer="Action In-"
                  textColor="white"
                  onTimerEnd={() =>
                    setBankBoxPanelState({ ...bankBoxPanelState })
                  }
                />
                &nbsp;
              </button>
            );
          } else {
            actionDiv = (
              <button
                className="btn btn-xs btn-warning mrg-all-0 bankbox-warning-btn"
                onClick={(e) =>
                  manualActionButtonClicked(
                    txn_id,
                    trancheID,
                    bankBoxPanelState,
                    setBankBoxPanelState,
                    e,
                  )
                }
                disabled={bankBoxPanelState.manualActionBtnDisabled[txn_id]}
              >
                Manual Action
              </button>
            );
          }
        } else {
          actionDiv = (
            <button
              className="btn btn-xs btn-warning mrg-all-0 bankbox-warning-btn"
              onClick={(e) =>
                manualActionButtonClicked(
                  txn_id,
                  trancheID,
                  bankBoxPanelState,
                  setBankBoxPanelState,
                  e,
                )
              }
              disabled={bankBoxPanelState.manualActionBtnDisabled[txn_id]}
            >
              Manual Action
            </button>
          );
        }
      } else if (+bank_txn_status === 9) {
        const { REACT_APP_ENABLE_BANKBOX_RETRY } = process.env;
        if (next_executeion_time) {
          const fromTime = new Date(next_executeion_time.slice(0, -1));
          const toTime = new Date();
          let timeLapsed = (fromTime - toTime) / 1000;

          if (timeLapsed > 0) {
            actionDiv = (
              <button
                className="btn btn-xs btn-danger disabled-anchor mrg-all-0 txn-timer bankbox-danger-btn"
                onClick={() =>
                  updateTransaction(
                    txn_id,
                    trancheID,
                    "release",
                    "",
                    "",
                    setBankBoxPanelState,
                    fetchListData,
                  )
                }
                disabled={bankBoxPanelState.manualActionBtnDisabled[txn_id]}
              >
                <Timer
                  totalTimeInSeconds={Math.round(timeLapsed)}
                  endingMinutes={0}
                  textWithTimer="Retry In-"
                  textColor="white"
                  onTimerEnd={() =>
                    setBankBoxPanelState({ ...bankBoxPanelState })
                  }
                />
                &nbsp;
              </button>
            );
          } else {
            if (+REACT_APP_ENABLE_BANKBOX_RETRY) {
              actionDiv = (
                <button
                  className="btn btn-xs btn-success mrg-all-0 bankbox-success-btn"
                  onClick={() =>
                    updateTransaction(
                      txn_id,
                      trancheID,
                      "release",
                      "",
                      "",
                      setBankBoxPanelState,
                      fetchListData,
                    )
                  }
                  disabled={bankBoxPanelState.manualActionBtnDisabled[txn_id]}
                >
                  Retry&nbsp;
                </button>
              );
            } else {
              actionDiv = "";
            }
          }
        } else {
          if (+REACT_APP_ENABLE_BANKBOX_RETRY) {
            actionDiv = (
              <button
                className="btn btn-xs btn-success mrg-all-0 bankbox-success-btn"
                onClick={() =>
                  updateTransaction(
                    txn_id,
                    trancheID,
                    "release",
                    "",
                    "",
                    setBankBoxPanelState,
                    fetchListData,
                  )
                }
                disabled={bankBoxPanelState.manualActionBtnDisabled[txn_id]}
              >
                Retry&nbsp;
              </button>
            );
          } else {
            actionDiv = "";
          }
        }
      } else {
        actionDiv = "";
      }
      break;
    default:
      break;
  }

  return actionDiv;
};

const manualActionButtonClicked = (
  txnId,
  trancheID,
  bankBoxPanelState,
  setBankBoxPanelState,
  e,
) => {
  setBankBoxPanelState({
    ...bankBoxPanelState,
    manualActionProps: {
      ...bankBoxPanelState.manualActionProps,
      txnNo: trancheID,
      reqType: "resubmit",
      txnId,
    },
  });
  setBankBoxPanelState((prevState) => ({
    ...prevState,
    showManualActionModal: true,
  }));
  e.stopPropagation();
};

const openReasonModal = (
  trancheID,
  reqType,
  bankBoxPanelState,
  setBankBoxPanelState,
  e,
) => {
  setBankBoxPanelState({
    ...bankBoxPanelState,
    reasonModalProps: {
      ...bankBoxPanelState.reasonModalProps,
      txnNo: trancheID,
      reqType,
    },
  });
  setBankBoxPanelState((prevState) => ({
    ...prevState,
    showReasonModal: true,
  }));
  e.stopPropagation();
};

const updateTransaction = async (
  txnId,
  txnNo,
  reqType,
  reason,
  reasonType,
  setBankBoxPanelState,
  fetchListData,
  utrNumber,
  file,
) => {
  if (window.confirm("Would you like to proceed?")) {
    const origTxnId = txnId;
    txnNo = encodeURIComponent(btoa(txnNo));
    txnId = encodeURIComponent(btoa(txnId));
    setBankBoxPanelState((prevState) => ({
      ...prevState,
      showManualActionModal: false,
      showReasonModal: false,
      manualActionBtnDisabled: {
        ...prevState.manualActionBtnDisabled,
        [origTxnId]: true,
      },
    }));
    try {
      const reqData = encryptRequest({
        request_type: reqType,
        txnNo,
        txn_reason: reason,
        utrNumber,
        txnId,
        txn_type: reasonType,
      });
      const data = new FormData();

      data.append("reqData", JSON.stringify(reqData));
      if (file) data.append("file", file);

      const result = await axios_instance({
        url: "/bankbox/transactionUpdate",
        method: "POST",
        data,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      const decryptedData = decryptRequest(result.data.resData);
      if (result.status === 200) {
        if (decryptedData.is_duplicate_utr) {
          window.alert(`UTR Duplicate with Loan ID ${decryptedData.loan_id}!`);
          setBankBoxPanelState((prevState) => ({
            ...prevState,
            showManualActionModal: true,
          }));
          return;
        }
        await fetchListData({
          msg: decryptedData.description,
          error: !decryptedData.success,
        });
      } else {
        await fetchListData({ msg: decryptedData.description, error: true });
      }
    } catch (error) {
      console.log(error);
      await fetchListData({
        msg: "Unable to update data, Please try again later!!",
        error: true,
      });
    }
    setBankBoxPanelState((prevState) => ({
      ...prevState,
      manualActionBtnDisabled: {
        ...prevState.manualActionBtnDisabled,
        [origTxnId]: false,
      },
    }));
  }
};

export {
  getTableStyles,
  getSortingClass,
  getTimeLapsedDiv,
  getActionDiv,
  updateTransaction,
  openReasonModal,
};
